/**
 * @module HandleWebPresupuestos
 */

import { tokenConfig } from '../../../../actions/auth'
import { createMessage } from '../../../../actions/messages'
import { getPedidoActivo } from '../../../../actions/pedidos'
import axios from '../../../../axiosConfig'

export const saveWebPresupuesto = (presupuesto, postGuardado) => (dispatch, getState) => {
  const body = JSON.stringify(presupuesto)
  axios
    .post(`/webpresupuestos`, body, tokenConfig(getState))
    .then(res => {
      dispatch(createMessage(res.data, 'success'))
      postGuardado()
    })
    .catch(err => console.log(err))
}

export const deleteWebPresupuesto = (id_pedido, postBorrado) => (dispatch, getState) => {
  axios
    .delete(`/webpresupuestos/${id_pedido}/`, tokenConfig(getState))
    .then(res => {
      dispatch(createMessage(res.data, 'success'))
      postBorrado()
    })
    .catch(err => console.log(err))
}

export const createOrderWebPresupuesto = (id_pedido, postCreacion) => (dispatch, getState) => {
  axios
    .get(`webpresupuestos/crear_pedido/?id_pedido=${id_pedido}`, tokenConfig(getState))
    .then(res => {
      dispatch(createMessage(res.data, 'success'))
      dispatch(getPedidoActivo('', 'S', ''))
      postCreacion()
    })
    .catch(err => console.log(err))
}

export const getWebPresupuestos =
  (
    fechaDesde,
    fechaHasta,
    sortBy,
    id,
    page,
    limit,
    setResponse,
    setNumeroRegistros,
    setLoading,
    setNext,
    setPrevious,
  ) =>
  (dispatch, getState) => {
    const body = JSON.stringify({
      fecha_desde: fechaDesde,
      fecha_hasta: fechaHasta,
      sort_by: sortBy,
      id_pedido: id,
    })
    setLoading(true)
    axios
      .post(
        `/webpresupuestos/get_web_presupuestos?page=${page}&page_size=${limit ?? 12}`,
        body,
        tokenConfig(getState),
      )
      .then(request_response => {
        setResponse(request_response.data.results)
        setNumeroRegistros(request_response.data.count)
        setNext(request_response.data.next)
        setPrevious(request_response.data.previous)

        setLoading(false)
      })
      .catch(request_error => {
        setLoading(false)
        dispatch(createMessage('Error recuperando presupuestos', 'error'))
      })
  }
